"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var components_1 = require("../../components");
var antd_1 = require("antd");
var ReceiverRequirements_1 = require("../../types/ReceiverRequirements");
var form_item_1 = __importDefault(require("../form-item"));
var react_intl_1 = require("react-intl");
var ConversionUtility_1 = require("../../../utils/ConversionUtility");
var formLayout_1 = require("../../consts/formLayout");
var CostCenter_1 = __importDefault(require("./CostCenter"));
var CustomerContactName_1 = __importDefault(require("./CustomerContactName"));
var translationMessages = react_intl_1.defineMessages({
    customer_title: {
        id: "customer_title",
        defaultMessage: "Customer",
    },
    customer_selectTheCustomer: {
        id: "customer_selectTheCustomer",
        defaultMessage: "Select the customer",
    },
    customer_name: {
        id: "customer_name",
        defaultMessage: "Name",
    },
    customer_identifier: {
        id: "customer_identifier",
        defaultMessage: "Identifier"
    },
    customer_address_streetNameAndNumber: {
        id: "customer_address_streetNameAndNumber",
        defaultMessage: "Address"
    },
    customer_address_zip_postalCode: {
        id: "customer_address_zipPostalCode",
        defaultMessage: "Zip/Postal code"
    },
    customer_address_city: {
        id: "customer_address_city",
        defaultMessage: "City"
    },
    customer_address_countryCode: {
        id: "customer_address_countryCode",
        defaultMessage: "Country code"
    },
    customer_contact_email: {
        id: "customer_contact_email",
        defaultMessage: "E-Mail"
    },
    customer_contact_name: {
        id: "customer_contact_name",
        defaultMessage: "Contact name"
    }
});
var Customer = function (props) {
    var chosenCustomer = props.chosenCustomer, setChosenCustomer = props.setChosenCustomer;
    var onCustomerChange = function (customerIndex) {
        var customerPartyMetadata = ConversionUtility_1.profileOutputToPartyMetadata(props.customers[customerIndex]);
        var prevValues = props.formInstance.getFieldsValue();
        var newFormValues = __assign({}, prevValues, { invoice: __assign({}, prevValues.invoice, { customer: __assign({}, prevValues.invoice.customer, customerPartyMetadata) }) });
        setChosenCustomer(__assign({}, prevValues.invoice.customer, customerPartyMetadata));
        props.setChosenCustomerApiKey(props.customers[customerIndex].apiKey);
        props.formInstance.setFieldsValue(newFormValues);
    };
    return (react_1.default.createElement(components_1.ComponentContainer, { title: props.intl.formatMessage(translationMessages.customer_title) },
        react_1.default.createElement(form_item_1.default, { receiverRequirements: props.receiverRequirements, defaultLabel: props.customers.length > 1
                ? props.intl.formatMessage(translationMessages.customer_selectTheCustomer)
                : props.intl.formatMessage(translationMessages.customer_title), defaultIsRequired: true, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["customer.identifier"], fieldName: ["invoice", "customer", "name"] }, props.customers.length > 1
            ?
                react_1.default.createElement(antd_1.Select, { onChange: function (value) {
                        onCustomerChange(value);
                    }, dropdownMatchSelectWidth: false, disabled: props.customers.length === 1 }, props.customers.map(function (customer, index) { return (react_1.default.createElement(antd_1.Select.Option, { key: index, value: index }, customer.name)); }))
            :
                props.customers.length === 0
                    ? "Error - no customer configured"
                    : props.customers[0].name),
        react_1.default.createElement(antd_1.Form.Item, __assign({}, formLayout_1.formItemLayout, { label: props.intl.formatMessage(translationMessages.customer_name), style: { display: "none" } }), chosenCustomer && chosenCustomer.name),
        react_1.default.createElement(antd_1.Form.Item, __assign({}, formLayout_1.formItemLayout, { label: props.intl.formatMessage(translationMessages.customer_identifier) }), chosenCustomer && ConversionUtility_1.convertToReadableKennitala(chosenCustomer.identifier)),
        react_1.default.createElement(antd_1.Form.Item, __assign({}, formLayout_1.formItemLayout, { label: props.intl.formatMessage(translationMessages.customer_address_streetNameAndNumber) }), chosenCustomer && chosenCustomer.address
            ? react_1.default.createElement(react_1.default.Fragment, null,
                chosenCustomer.address.streetNameAndNumber,
                react_1.default.createElement("br", null),
                chosenCustomer.address.postalZone,
                ", ",
                chosenCustomer.address.city,
                ", ",
                chosenCustomer.address.countryCode)
            : null),
        chosenCustomer && chosenCustomer.identifier &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(CostCenter_1.default, { receiverRequirements: props.receiverRequirements, updateReceiverRequirementsProp: props.updateReceiverRequirementsProp, rapiBaseUrl: props.rapiBaseUrl, legalIdentifier: chosenCustomer.identifier, formInstance: props.formInstance }),
                react_1.default.createElement(CustomerContactName_1.default, { receiverRequirements: props.receiverRequirements, updateReceiverRequirementsProp: props.updateReceiverRequirementsProp, rapiBaseUrl: props.rapiBaseUrl, legalIdentifier: chosenCustomer.identifier, formInstance: props.formInstance }))));
};
var CustomerIntl = react_intl_1.injectIntl(Customer);
exports.default = CustomerIntl;
